import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={101}
    height={props.width? `calc( ${props.width}/ 101 * 101 )`: 101}
    viewBox="0 0 101 101"
    fill="none"
    {...props}
  >
    <path
      fill="url(#aqa)"
      stroke="#00A4AF"
      d="M74.745 7.266 99.471 50.5 74.745 93.734H25.301L.577 50.5 25.302 7.266h49.443Z"
    />
    <g filter="url(#bqa)">
      <path
        fill="#00A4AF"
        fillOpacity={0.2}
        d="M73.087 26 57.412 41.467a14.65 14.65 0 0 1 2.197 7.732c0 7.201-5.194 13.2-12.086 14.561L51.638 85c17.025-3.262 29.885-18.045 29.885-35.797 0-8.813-3.166-16.892-8.436-23.199V26Z"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="M73.002 27.488c4.716 6.005 7.521 13.534 7.521 21.715 0 16.913-12.011 31.07-28.096 34.614l-3.738-19.3c6.853-1.8 11.92-7.964 11.92-15.318 0-2.738-.705-5.317-1.942-7.565l14.335-14.146Z"
      />
    </g>
    <g filter="url(#cqa)">
      <path
        fill="#00A4AF"
        fillOpacity={0.2}
        d="M54.426 17.11c-3.14-.159-7.006-.248-9.903.48l2.298 17.741c1.572-.395 5.035-.541 6.68.012 4.135.212 7.696 2.4 9.818 5.606l15.178-9.92c-5.17-8.171-13.679-13.39-24.07-13.919Z"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="m45.633 18.373 2.044 15.784c.742-.103 1.6-.164 2.444-.175 1.234-.017 2.582.072 3.563.37a13.5 13.5 0 0 1 9.89 5.236l13.538-8.848c-5.038-7.425-13.027-12.136-22.736-12.631l-8.743.264Zm0 0c2.619-.483 5.908-.408 8.742-.264l-8.742.264Z"
      />
    </g>
    <g filter="url(#dqa)">
      <path
        fill="#00A4AF"
        fillOpacity={0.2}
        d="M56.837 63.435a14.592 14.592 0 0 1-11.239 3.207c-8.006-1.074-13.628-8.437-12.554-16.443 1.074-8.006 8.437-13.628 16.443-12.554.525.07 1.038.168 1.543.293l1.852-13.804a28.63 28.63 0 0 0-1.549-.253c-15.608-2.093-29.959 8.863-32.052 24.472-2.094 15.608 8.862 29.959 24.47 32.053 8.367 1.121 16.368-1.508 22.314-6.588l-9.231-10.383h.003Z"
      />
      <path
        stroke="#fff"
        strokeWidth={2}
        d="M45.465 67.633a15.577 15.577 0 0 0 11.243-2.835l7.92 8.908c-5.648 4.476-13.035 6.742-20.743 5.708-15.061-2.02-25.633-15.867-23.613-30.928 2.02-15.062 15.867-25.633 30.928-23.613.188.025.376.052.563.081l-1.58 11.786a15.39 15.39 0 0 0-.563-.086c-8.553-1.147-16.42 4.858-17.567 13.412-1.147 8.553 4.858 16.42 13.412 17.567Z"
      />
    </g>
    <defs>
      <filter
        id="bqa"
        width={44}
        height={69}
        x={42.523}
        y={21}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_58_2272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_58_2272"
          result="shape"
        />
      </filter>
      <filter
        id="cqa"
        width={43.974}
        height={33.949}
        x={39.523}
        y={12}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_58_2272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_58_2272"
          result="shape"
        />
      </filter>
      <filter
        id="dqa"
        width={57.041}
        height={67.037}
        x={14.024}
        y={18.625}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={2.5} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_58_2272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_58_2272"
          result="shape"
        />
      </filter>
      <radialGradient
        id="aqa"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-50.0236 0 0 -50.5 50.023 50.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2EE6FF" stopOpacity={0.5} />
        <stop offset={1} stopColor="#2EE6FF" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
)
export default SvgComponent
